import apiClient from '../authentication/utils/core/axios';

/**
 * API service layer for user stock alerts
 */
const UserStockAlertsAPI = {
  create: async (data) => {
    const response = await apiClient.post('/alerts/', data);
    if (response.status !== 201 && response.status !== 200) {
      throw new Error('Failed to create alert');
    }
    return response.data;
  },

  // Backend route is /alerts/me (current authenticated user, no user_id param) --
  // there is no /alerts/user/{userId} route.
  fetchByUser: async () => {
    const response = await apiClient.get(`/alerts/me`);
    if (response.status !== 200) {
      throw new Error('Failed to fetch alerts');
    }
    return response.data;
  },

  update: async (alertId, data) => {
    const response = await apiClient.put(`/alerts/${alertId}`, data);
    if (response.status !== 200) {
      throw new Error('Failed to update alert');
    }
    return response.data;
  },

  delete: async (alertId) => {
    const response = await apiClient.delete(`/alerts/${alertId}`);
    if (response.status !== 204) {
      throw new Error('Failed to delete alert');
    }
    return alertId;
  }
};

export default UserStockAlertsAPI